import { render, staticRenderFns } from "./RSelectedItems.vue?vue&type=template&id=4e0a30b8&scoped=true"
import script from "./RSelectedItems.vue?vue&type=script&lang=js"
export * from "./RSelectedItems.vue?vue&type=script&lang=js"
import style0 from "./RSelectedItems.vue?vue&type=style&index=0&id=4e0a30b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a30b8",
  null
  
)

export default component.exports